"use strict"
exports.__esModule = true;
exports.AffiliatethemeIconConfig = {
  name: 'AffiliatethemeIcon',
  height: 512,
  width: 512,
  svgPath: 'M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z',
  yOffset: 0,
  xOffset: 0,
};
exports.AffiliatethemeIcon = require('../createIcon').createIcon(exports.AffiliatethemeIconConfig);
exports["default"] = exports.AffiliatethemeIcon;